module.exports = __webpack_public_path__ + "assets/img/complete.8dfede40.png";